<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="false"
    width="720px"
  >
    <div>
      <div class="pd10-y">请选择需要的表头字段，并排序：</div>
      <el-alert title="【您选的表头字段会在excel上展示，同时该字段的内容会自动复制到Excel表格上】" type="warning">
      </el-alert>
      <el-checkbox v-model="checkAll" class="pd10-y" :indeterminate="isIndeterminate" @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <el-checkbox-group v-model="checked" class="mb10">
        <el-checkbox v-for="(val, index) in checkbox" :key="index" :label="val" class="checkbox_item">{{
          val
        }}</el-checkbox>
      </el-checkbox-group>
      <div class="mb10">拖拽即可排列表头顺序</div>
      <div id="checkedList" class="flex-row flex-wrap mb10">
        <div v-for="(val, i) in checked" :key="i" :index="i" class="mr10 mb10 checked_item">{{ val }}</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" @click="onConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  data() {
    return {
      visible: false,
      checkAll: false,
      checkbox: [],
      checked: ['姓名', '进展', '进展时间', '公司', '目前职位'],
      isIndeterminate: false,
    }
  },
  watch: {
    checked: {
      handler: function(val, oldVal) {
        this.sortChecked = val
      },
      immediate: true,
    },
  },
  created() {
    this.checkbox = [
      '姓名',
      '进展',
      '进展时间',
      '公司',
      '目前职位',
      '意向',
      '性别',
      '长期意向',
      '地域',
      '曾任职公司',
      '离职意愿度',
      '当前薪酬',
      '工作经历',
      '简介',
      '教育经历',
      '出生年月',
      '婚育',
      '职能模块',
      '细分职能',
      '擅长方向',
      '个性标签',
      '职级',
      '管理职级',
      '专业职级',
      '业绩',
      '行业',
      '规模',
      '管理基金数量',
      '任职期',
      '管理基金',
      '投资风格',
      '口碑打分',
      '部门',
      '组别',
      '学历标签',
      '语言标签',
      '沟通日志',
      '备注',
      '本科院校',
      '硕士院校',
      '从业起始年',
      '获奖经历',
      '学历',
    ]
  },
  methods: {
    open(pid) {
      this.pid = pid
      this.checked = ['姓名', '进展', '进展时间', '公司', '目前职位']
      this.checkAll = false
      this.isIndeterminate = false
      this.visible = true
      this.$nextTick(_ => {
        const sortableEl = document.getElementById('checkedList')
        const exchange = evt => {
          const arr = evt.to.children
          const result = []
          for (let i = 0, len = arr.length; i < len; i += 1) {
            result.push(arr[i].innerText)
          }
          this.sortChecked = result
        }
        this.sortable = Sortable.create(sortableEl, {
          onUpdate: function(evt) {
            exchange(evt)
          },
        })
      })
    },
    handleCheckAllChange(val) {
      this.checked = val ? this.checkbox : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.checkbox.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkbox.length
    },
    async onConfirm() {
      const loading = this.$loading({
        lock: true,
        text: '正在获取人选mapping报告，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const res = await app.service('project').getProjectMappingReport({
          pid: this.pid,
          header: this.sortChecked,
        })
        if (res && res.status === 'success' && res.data) {
          app.root.$refs.WpsDialog.open({
            url: res.data.url,
            md5: res.data.md5,
            documentType: res.data && res.data.documentType,
            fileType: res.data && res.data.fileType,
            originalname: res.data && res.data.originalname,
          })
        } else this.$message.error(res.msg)
      } catch (e) {
        console.error(e)
        this.$message.error(`生成人选mapping报告出错`)
      }
      loading.close()
    },
  },
}
</script>

<style scoped>
.checkbox_item {
  width: 100px;
}
.headers_item {
  display: inline-block;
  background-color: rgb(255, 153, 0);
  padding: 5px;
  color: #fff;
  border-radius: 4px;
  border: 1px solid rgba(255, 109, 0, 0.1);
}
.checked_item {
  display: inline-block;
  background-color: rgb(255, 153, 0);
  padding: 5px;
  color: #fff;
  border-radius: 4px;
  border: 1px solid rgba(255, 109, 0, 0.1);
}
</style>
